<template>
  <div class="card_head_w d_flex align_item_c justify_content_sb">
    <div :class="titleClass" class="default_title c_1A1A1A">
      {{ title }}
      <slot name="title" />
    </div>

    <div class="default_oper cursor_pointer">
      <slot name="oper" />
    </div>

  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    titleClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.card_head_w{
  height: 36px;
  // border-bottom: 1px solid #e6e6e6;
  .default_title{
    font-size: 14px;
  }
}
</style>
